export default __webpack_public_path__ + "static/thebottomline28-7be90d3a3eaafa0f356ad4c92af3dea2.jpg";